import Swal from "sweetalert2";
import api from "../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY



export const getEficienciaServicio = async (params,setDataEficiencia) => {


    await api.get(`${urlApi}/dashboard/getServiceEfficiency?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        console.log("res",res);
        setDataEficiencia(res.data)
    })
    .catch((error)=>
    {
        console.log("error en dashboard",error);
        
    })
}
export const getBitacorasCorrectasIncorectasCont = async (params,setStatus) => {


    await api.get(`${urlApi}/dashboard/getBitacorasCorrectasIncorectasCont?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        setStatus(res.data.length)
    })
    .catch((error)=>
    {
        console.log("error en dashboard",error);
        
    })
}
export const getModalKmVsRutasCont = async (setStatus) => {


    await api.get(`${urlApi}/dashboard/getModalKmVsRutasCont`)
    .then((res) => {
        setStatus(res.data.CONTEO)
    })
    .catch((error)=>
    {
        console.log("error en dashboard",error);
        
    })
}
export const getRotacionDeOperadores = async (params,setData,setLoading) => {


    await api.get(`${urlApi}/dashboard/getRotacionDeOperadores?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en dashboard",error);
        
    })
}
export const getBitacorasCorrectasIncorectas = async (params,setData,setLoading) => {


    await api.get(`${urlApi}/dashboard/getBitacorasCorrectasIncorectas?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en getBitacorasCorrectasIncorectas",error);
        
    })
}
export const getBitacorasVsRegistroAforo = async (params,setData) => {


    await api.get(`${urlApi}/dashboard/getBitacorasVsRegistroAforo?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
    })
    .catch((error)=>
    {
        console.log("error en getBitacorasVsRegistroAforo",error);
        
    })
}
export const getRotacionDeOperadoresCont = async (params,setData) => {


    await api.get(`${urlApi}/dashboard/getRotacionDeOperadoresCont?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}`)
    .then((res) => {
        console.log("res",res);
        setData(res.data.CONTEO)
    })
    .catch((error)=>
    {
        console.log("error en getBitacorasVsRegistroAforo",error);
        
    })
}
export const getModalKmVsRutas = async (setData,setLoading) => {


    await api.get(`${urlApi}/dashboard/getModalKmVsRutas`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en getBitacorasVsRegistroAforo",error);
        
    })
}
export const getSencibilidadDelCliente = async (setData,setLoading) => {


    await api.get(`${urlApi}/dashboard/getSencibilidadDelCliente`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en getSencibilidadDelCliente",error);
        
    })
}
export const getSencibilidadDelClienteCount = async (setData) => {


    await api.get(`${urlApi}/dashboard/getSencibilidadDelClienteCount`)
    .then((res) => {
        setData(res.data.PROMEDIO_SENSIBILIDAD)
    })
    .catch((error)=>
    {
        console.log("error en getSencibilidadDelCliente",error);
        
    })
}
export const getCheckListSumaDriversCont = async (params,setData) => {


    await api.get(`${urlApi}/dashboard/getCheckListSumaDriversCont?fecha_inicio=${params.fecha_inicio}`)
    .then((res) => {
        setData(res.data.CONTEO)
    })
    .catch((error)=>
    {
        console.log("error en getSencibilidadDelCliente",error);
        
    })
}
export const getCheckListSumaDrivers = async (params,setData,setLoading) => {


    await api.get(`${urlApi}/dashboard/getCheckListSumaDrivers?fecha_inicio=${params.fecha_inicio}`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en getCheckListSumaDrivers",error);
        
    })
}
export const getInformacionDeLosClientes = async (setData,setLoading) => {
    await api.get(`${urlApi}/dashboard/getInformacionClientes`)
    .then((res) => {
        console.log("res",res);
        setData(res.data)
        setLoading(false)
    })
    .catch((error)=>
    {
        console.log("error en getCheckListSumaDrivers",error);
        
    })
}